import "./spinner.css";
import Toaster from "../Toast/Toast";
import { routes } from "../../routes";
import { useNavigate } from "react-router-dom";
import CommonModal from "../CommonModal/CommonModal";
import WheelComponent from "../WheelPrize/WheelPrize";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, forwardRef } from "react";
import { toggleLoader } from "../../redux/slices/loaderSlice";
import BackdropLoader from "../BackdropLoader/BackdropLoader";
import SpinWinModal from "../../pages/SpinWinModal/SpinWinModal";
import { userVerificationEmail } from "../../api/modules/b2droppie.class";

const Spinner = forwardRef(
  (
    {
      unbox,
      boxId,
      boxPrice,
      boximage,
      itemsData,
      setRefetch,
      spinnerData,
      onStateChange,
      boxFormatedPrice,
    },
    ref,
  ) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showSpin, setShowSpin] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasFreeBox, setHasFreeBox] = useState(false);
    const [callbackData, setCallbackData] = useState(null);
    const user = useSelector((state) => state?.auth?.user);
    const isDarkMode = useSelector((state) => state.theme.darkMode);
    const [message, setMessage] = useState({ success: "", error: "" });
    const [winner, setWinner] = useState({ winnerId: "", unboxId: "" });
    const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false);

    useEffect(() => {
      dispatch(toggleLoader({ isLoading: false }));
    }, [dispatch]);

    useEffect(() => {
      if (
        unbox?.hidden_from_shop &&
        user?.free_boxes &&
        user?.free_boxes_remaining > 0
      ) {
        setHasFreeBox(true);
      }
      if (showSpin || callbackData) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }

      return () => {
        document.body.style.overflow = "";
      };
    }, [showSpin, callbackData]);

    const userEmailVerification = async () => {
      try {
        const response = await userVerificationEmail({
          email: user?.email,
        });
        setMessage({
          success: response?.data?.message || "",
          error: response?.data?.error?.message || "",
        });
        if (response?.data?.success) {
          setShowVerifyEmailModal(false);
        }
      } catch (err) {
        console.error(err);
        setMessage({
          success: "",
          error: "Something went wrong. Try again.",
        });
      } finally {
        setShowVerifyEmailModal(false);
      }
    };

    return (
      <>
        <Toaster message={message} />
        <div className={isDarkMode ? "AppDark" : "AppLight"}>
          <WheelComponent
            ref={ref}
            unbox={unbox}
            winner={winner}
            showSpin={showSpin}
            boxPrice={boxPrice}
            boximage={boximage}
            itemsData={itemsData}
            setWinner={setWinner}
            setRefetch={setRefetch}
            isDarkMode={isDarkMode}
            spinnerData={spinnerData}
            setShowSpin={setShowSpin}
            onStateChange={onStateChange}
            boxFormatedPrice={boxFormatedPrice}
          />
        </div>

        {/* ===== SPIN MODAL ===== */}
        <SpinWinModal
          unbox={unbox}
          boxId={boxId}
          winner={winner}
          navigate={navigate}
          showSpin={showSpin}
          itemsData={itemsData}
          setMessage={setMessage}
          setShowSpin={setShowSpin}
          setIsLoading={setIsLoading}
          setCallbackData={setCallbackData}
          setShowVerifyEmailModal={setShowVerifyEmailModal}
        />

        <CommonModal
          show={showVerifyEmailModal}
          onClose={() => setShowVerifyEmailModal(false)}
          onConfirm={() => userEmailVerification()}
          title={
            <h4
              className={`${isDarkMode ? "text-light-lavender-purple" : "text-deep-purple"} w-100 d-center`}
            >
              Email not Verified!
            </h4>
          }
          body={
            <>
              <p
                className={`${isDarkMode ? "text-muter-lavender-purple" : "text-charcoal-gray"} mb-2`}
              >
                Please verify your email address. Click Here to generate an
                email.
              </p>
            </>
          }
          showFooter={true}
          modalWidth="w-lg-35"
          isDarkMode={isDarkMode}
          confirmText="Send Email!"
          btnStyle="filled-danger-btn-dark"
        />

        {/* ===== SUCCESS / ERROR DIALOG ===== */}
        {callbackData && (
          <div
            className={`payment-callback-overlay ${isDarkMode ? "dark" : "light"}`}
          >
            <div
              className="payment-callback-card"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="payment-callback-close"
                onClick={() => {
                  if (hasFreeBox) {
                    navigate(routes.FREEBOXES, { replace: true });
                  } else if (unbox?.hidden_from_shop) {
                    navigate(routes.HOME, { replace: true });
                  } else setCallbackData(null);
                }}
              >
                ✕
              </button>

              <div
                className={`payment-callback-icon ${
                  callbackData.type === "success" ? "success" : "error"
                }`}
              >
                {callbackData.type === "success" ? "✓" : "✕"}
              </div>
              <div>
                <h2
                  className={`payment-callback-title ${
                    callbackData.type === "success" ? "success" : "error"
                  }`}
                >
                  {callbackData.title}
                </h2>

                <p className="payment-callback-subtitle">
                  {callbackData.subtitle}
                </p>
              </div>
            </div>
          </div>
        )}
        <BackdropLoader show={isLoading} />
      </>
    );
  },
);

Spinner.displayName = "Spinner";
export default Spinner;
